/**
 * Lineage app root — routing + auth provider.
 *
 * Routes:
 *   /               Home (unauth: "woven in silence" placeholder + Enter link;
 *                         auth + Orchist: identity stub + Invite link;
 *                         auth + pending: redirects to /acknowledge)
 *   /login          Email OTP entry form
 *   /auth/callback  Handles the Supabase magic-link return; routes invitees to
 *                   /acknowledge based on Contact state
 *   /invite         Existing Orchist invites another soul into The Line (Phase G.1)
 *   /acknowledge    Newly invited soul confirms entry into The Line (Phase G.3)
 *
 * AuthProvider wraps everything so any component can useAuth().
 */

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import Home from '@/routes/Home';
import Login from '@/routes/Login';
import AuthCallback from '@/routes/AuthCallback';
import Invite from '@/routes/Invite';
import Acknowledge from '@/routes/Acknowledge';
import VerifyEmail from '@/routes/VerifyEmail';
import AnchorAttestation from '@/routes/AnchorAttestation';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/invite" element={<Invite />} />
          <Route path="/acknowledge" element={<Acknowledge />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/anchor-attestation" element={<AnchorAttestation />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
